import * as React from "react";
import {imageBaseUrl} from "config";
import {useState} from "react";
import NetBanking from "IncompleteInfoV2/BankStatementV2/BSModes/NetBanking";
import PdfUpload from "IncompleteInfoV2/BankStatementV2/BSModes/PdfUpload";
import OnboardEmail from "IncompleteInfoV2/BankStatementV2/BSModes/OnboardEmail";
import "IncompleteInfoV2/BankStatementV2/BSModes/style.scss";
import Flashcard from "myshubhlife-component/Flashcard";
import {MessageType} from "utils/variables";
import {partnerOfferings} from "login/config";
import {IBankDetails} from "IncompleteInfoV2/BankStatementV2/";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";

export enum Modes {
    NET_BANKING = "NET_BANKING",
    PDF_UPLOAD = "PDF_UPLOAD",
    GOOGLE_FORM = "GOOGLE_FORM",
    BS_PDF_NET_AA = "BS_PDF_NET_AA",
}

interface IProps {
    bsModes: Modes[];
    userId?: number;
    isAllowedToUpload: boolean;
    applicationId: number;
    onboardEmailRequired: boolean;
    utm_source?: string;
    aggregatorDetail: string;
    isAndroid: boolean;
    apiVersion: number;
    bankDetails?: IBankDetails;
}
const modeMap = {
    [Modes.NET_BANKING]: {
        icon: `${imageBaseUrl}/img/icons/bank-transfer.png`,
        title: "Net Banking",
    },
    [Modes.PDF_UPLOAD]: {
        icon: `${imageBaseUrl}/img/icons/pdf-dark-icon.png`,
        title: "PDF upload",
    },
    [Modes.GOOGLE_FORM]: {
        icon: `${imageBaseUrl}/img/icons/google-drive-icon.png`,
        title: "Google Form",
    },
    [Modes.BS_PDF_NET_AA]: {
        icon: `${imageBaseUrl}/img/icons/account-aggregator.png`,
        title: "Upload Via OTP",
    },
};

const ErrorDesc = "Selected Bank doesn't support Net Banking";
const defaultErrorMsg = "For further queries please contact support";

export const BsModes = (props: IProps) => {
    const handleAggregatorRedirect = () => {
        if (props.isAndroid) {
            setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
        }
        const aggregatorDetails = {
            aggregatorDetails: props.aggregatorDetail,
            ...props.bankDetails,
        };
        sessionStorage.setItem("aggregator_details", JSON.stringify(aggregatorDetails));
        return window.open(props.aggregatorDetail, "_self");
    };

    const [selectedMode, setSelectedMode] = useState<string>(null);
    const renderSelectedMode = (mode: string) => {
        switch (mode) {
            case Modes.GOOGLE_FORM:
                googleFormUpload();
                break;
            case Modes.NET_BANKING:
                return props.bankDetails?.id && <NetBanking institutionId={props.bankDetails?.id} applicationId={props.applicationId}/>;
            case Modes.PDF_UPLOAD:
                return props.bankDetails?.id && <PdfUpload institutionId={props.bankDetails?.id}/>;
            case Modes.BS_PDF_NET_AA:
                return handleAggregatorRedirect();
            default: break;
        }
    };

    const googleFormUpload = () => {
        window.location.replace(`https://docs.google.com/forms/d/e/1FAIpQLSd6OmxcK5nEEV9zwAegf1iyM81108-uYQCoIBC49ZqAfumVmg/viewform?usp=pp_url&entry.1533748997=${props.userId}`);
    };

    return (
        <div className="bs-mode-container">
            {
                selectedMode ? renderSelectedMode(selectedMode) :
                <>
                    {!!props.bsModes.length && <h5 className="heading">Please select mode</h5>}
                    <div className="bs-modes">
                    {
                        !!props.bsModes.length && props.bsModes.map((mode, index) => {
                            return(
                                <div
                                key={index}
                                className="mode"
                                onClick={() => setSelectedMode(mode)}
                                >
                                    <img src={modeMap[mode].icon} alt="bs-mode-icon"/>
                                    <div>{modeMap[mode].title}</div>
                                </div>
                            );
                        })
                    }
                    {!props.bsModes.length &&
                        <Flashcard
                          messageType={MessageType.ERROR}
                          heading={""}
                          description={ErrorDesc}
                          supportEmail={true}
                          supportText={defaultErrorMsg}
                          supportEmailText={partnerOfferings[props.utm_source]?.supportEmail}
                          />}
                    </div>
                    {
                        props.onboardEmailRequired && !props.aggregatorDetail &&
                        <>
                            <h5>or</h5>
                            <OnboardEmail
                                userId={props.userId}
                                allowedToUpload={props.isAllowedToUpload}
                            />
                        </>
                    }
                </>
            }
        </div>
    );
};
